

const ACCESS_TOKEN_STORAGE_KEY = 'pearl_access_token';

let accessToken = null;

const readStoredAccessToken = () => {
  try {
    return sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
};

const writeStoredAccessToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    }
  } catch {
    // Ignore storage errors (private browsing, quota, etc.)
  }
};

export const getAccessToken = () => {
  if (accessToken) {
    return accessToken;
  }

  const storedToken = readStoredAccessToken();
  if (storedToken) {
    accessToken = storedToken;
    return storedToken;
  }

  return null;
};

export const setAccessToken = (token) => {
  accessToken = token || null;
  writeStoredAccessToken(accessToken);
  window.dispatchEvent(new Event('auth-token-updated'));
};

export const clearAccessToken = () => {
  accessToken = null;
  writeStoredAccessToken(null);
  window.dispatchEvent(new Event('auth-token-updated'));
};

export const clearLegacyTokenStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('refresh_token');
};
